"use strict";exports.__esModule = true;exports.default = void 0;var _makeupExpander = _interopRequireDefault(require("makeup-expander"));
var _makeupFocusables = _interopRequireDefault(require("makeup-focusables"));function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _default =

{
  handleExpand() {
    this.emit('base-expand');
  },

  handleCollapse() {
    this.emit('base-collapse');
  },

  onMount() {
    this._setupBaseTooltip();
  },

  onUpdate() {
    this._setupBaseTooltip();
  },

  onInput(input) {
    if (input.open === true) {
      this.action = 'expand';
    } else if (input.open === false) {
      this.action = 'collapse';
    }
  },

  onRender() {
    if (typeof window !== 'undefined') {
      this._cleanupMakeup();
    }
  },

  collapse() {
    this._expander.expanded = false;
  },

  expand() {
    this._expander.expanded = true;
  },

  isExpanded() {
    return this._expander.expanded;
  },

  onDestroy() {
    this._cleanupMakeup();
  },

  _setupExpander(host, hostSelector) {
    var { input } = this;
    var { type } = input;
    var container = this.getEl('container');
    var isTooltip = type === 'tooltip';
    var isInfotip = type === 'infotip';
    var isTourtip = type === 'tourtip';
    var expanderEl = container.getElementsByClassName(type)[0];

    if (host && !isTourtip) {
      this._expander = new _makeupExpander.default(expanderEl, {
        hostSelector: hostSelector,
        contentSelector: "." + type + "__overlay",
        expandedClass: type + "--expanded",
        focusManagement: null,
        expandOnFocus: isTooltip,
        expandOnHover: isTooltip && !input.noHover,
        expandOnClick: isInfotip,
        autoCollapse: isTooltip });


      if (isTooltip && !host.hasAttribute('aria-describedby')) {
        host.setAttribute('aria-describedby', input.overlayId);
      }
    }
  },

  _setupBaseTooltip() {
    if (this.input.type !== 'dialog--mini') {
      this._setupMakeup();
    }
    if (this.action && this._expander) {
      if (this.action === 'expand') {
        this.expand();
      } else if (this.action === 'collapse') {
        this.collapse();
      }
      this.action = null;
    }
  },

  _setupMakeup() {
    var { input } = this;
    var { type } = input;
    var container = this.getEl('container');
    var hostClass = type + "__host";
    var hostSelector = "." + hostClass;
    var host = container.querySelector(hostSelector);

    if (!host) {
      if (this.cancelFocus) {
        this.cancelFocus();
      }

      this.cancelFocus = (0, _makeupFocusables.default)(container, false, (curFocusables) => {
        var curFocusable = curFocusables[0];
        if (curFocusable) {
          host = curFocusable;

          if (!curFocusable.classList.contains(hostClass)) {
            curFocusable.classList.add(hostClass);
          }
        }
        this._setupExpander(host, hostSelector);
      });
    } else {
      this._setupExpander(host, hostSelector);
    }
  },

  _cleanupMakeup() {
    if (this.cancelFocus) {
      this.cancelFocus();
    }

    if (this._expander) {
      this._expander.destroy();
      this._expander = undefined;
    }
  } };exports.default = _default;module.exports = exports.default;